
import React from 'react'

import ChipRectangle from 'components/ChipRectangle'

const ALLURES_2024_TOP_PICKS_TEXT = 'Allure\'s 2024 Picks'

/**
 * @param {ProductBadgesProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductBadgeAllures2024TopPicks (props) {
  const {
    isAllures2024TopPicks
  } = props

  if (!isAllures2024TopPicks) {
    return <></>
  }

  return (
    <ChipRectangle>
      {ALLURES_2024_TOP_PICKS_TEXT}
    </ChipRectangle>
  )
}
